import React, { useState } from "react";
import "./infor.css";

const Infor = ({ closeInfor }) => {
  const [selectedMethod, setSelectedMethod] = useState("delivery");
  return (
    <div className="infor-container">
      <div className="info-content">
        <div className="method-tabs">
          <button
            className={`tab ${selectedMethod === "delivery" ? "active" : ""}`}
            onClick={() => setSelectedMethod("delivery")}
          >
            Delivery Info
          </button>
          <button
            className={`tab ${selectedMethod === "pickup" ? "active" : ""}`}
            onClick={() => setSelectedMethod("pickup")}
          >
            Self Pickup Info
          </button>
        </div>

        {selectedMethod === "delivery" ? (
          <div className="delivery-info">
            <p>
              <strong>Delivery Zone:</strong> A delivery zone is the region
              where your package will be delivered.
            </p>
            <p>Click on the dropdown to select your preferred zone.</p>
            <p>
              <strong>Street Name:</strong> This specifies the exact delivery
              location within your selected zone.
            </p>
          </div>
        ) : (
          <div className="pickup-info">
            <p>
              <strong>Store Pickup:</strong> Select your preferred store
              location from the dropdown list.
            </p>
            <p>
              <strong>Valid ID:</strong> Please bring a government-issued ID
              matching your order details when picking up.
            </p>
            <p>
              <strong>Order ID:</strong> Show your order ID to the store staff
              for verification.
            </p>
            <p>
              <strong>Pickup Hours:</strong> Stores are open for pickup between
              9:00 AM - 6:00 PM daily.
            </p>
          </div>
        )}

        <div className="common-info">
          <p>
            <strong>Contact Information:</strong> Your name, phone number, and
            email help us reach you regarding your order.
          </p>
          <p>
            Your details are securely stored, so you don’t have to enter them
            every time you make a purchase.
          </p>
          <p>
            We do not share your data or use it for advertising unless you
            provide consent.
          </p>
        </div>

        <button className="close-info" onClick={closeInfor}>
          Close
        </button>
      </div>
    </div>
  );
};

export default Infor;
